import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { V3HomeRoutingModule } from './v3-home-routing.module';
import { V3HomeComponent } from './v3-home.component';
import { SharedRoutingModule } from '../shared/shared-routing.module';
import { SharedModule } from '../shared/shared.module';
 
import { NgOptimizedImage } from '@angular/common';
import { FooterModule } from '../global/footer/footer.module';
import { GlobalDepartmentModule } from '../global/global-department/global-department.module';
import { ScrollTopModule } from 'primeng/scrolltop';

import { TestimonialsModule } from '../components/testimonials/testimonials.module';
import { NewFooterModule } from '../global/new-footer/new-footer.module';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';

@NgModule({
  declarations: [
    V3HomeComponent
  ],
  imports: [
    CommonModule,
    V3HomeRoutingModule,
    SharedRoutingModule,
    SharedModule,
    NgOptimizedImage,
    FooterModule,
    NewFooterModule,
    GlobalDepartmentModule,
    ScrollTopModule,
    TestimonialsModule,
    InputNumberModule,
    SidebarModule,
    DialogModule
  ],
})
export class V3HomeModule { }
